import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { Textarea } from "@/components/ui/Textarea";

type Props = {
  icon: ReactNode;
  channel: string;
  hint?: string;
  value: string;
  onChange: (value: string) => void;
  /** Limite consigliato caratteri (soft warning oltre) */
  softLimit?: number;
  /** Limite hard (errore oltre) */
  hardLimit?: number;
  placeholder?: string;
  disabled?: boolean;
  rows?: number;
  /** Se presente, mostra come modificato rispetto al valore originale */
  dirty?: boolean;
};

export function ChannelTextCard({
  icon,
  channel,
  hint,
  value,
  onChange,
  softLimit,
  hardLimit,
  placeholder,
  disabled,
  rows = 6,
  dirty,
}: Props) {
  const len = value.length;
  const overSoft = softLimit ? len > softLimit : false;
  const overHard = hardLimit ? len > hardLimit : false;

  return (
    <div className="flex flex-col rounded-lg border border-slate-200 bg-white shadow-sm">
      <div className="flex items-center justify-between gap-2 border-b border-slate-100 px-4 py-2.5">
        <div className="flex items-center gap-2">
          <div className="text-slate-500">{icon}</div>
          <div>
            <div className="text-sm font-semibold text-slate-900">
              {channel}
              {dirty ? (
                <span
                  className="ml-1.5 inline-block h-1.5 w-1.5 rounded-full bg-amber-500"
                  title="Modificato, non salvato"
                />
              ) : null}
            </div>
            {hint ? (
              <div className="text-[11px] text-slate-500">{hint}</div>
            ) : null}
          </div>
        </div>
        {softLimit || hardLimit ? (
          <div
            className={cn(
              "text-xs font-mono tabular-nums",
              overHard
                ? "text-red-700"
                : overSoft
                  ? "text-amber-700"
                  : "text-slate-400",
            )}
          >
            {len}
            {hardLimit ? `/${hardLimit}` : softLimit ? ` (soft ${softLimit})` : ""}
          </div>
        ) : null}
      </div>
      <div className="p-3">
        <Textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          rows={rows}
          className="font-mono text-[13px] leading-relaxed"
        />
      </div>
    </div>
  );
}
